import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Box = makeShortcode("Box");
const Heading = makeShortcode("Heading");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`When designing with colors consider the following to make your UI visually accessible.`}</p>
    <h3>{`Assure adequate color contrast`}</h3>
    <p>{`Color contrast between text and its background must meet `}<a parentName="p" {...{
        "href": "https://www.w3.org/WAI/WCAG21/Understanding/contrast-minimum.html"
      }}>{`required WCAG standards`}</a>{`.`}</p>
    <p>{`The contrast requirements are:`}</p>
    <ul>
      <li parentName="ul">{`4.5:1 for normal text`}</li>
      <li parentName="ul">{`3:1 for large text (>24px)`}</li>
      <li parentName="ul">{`3:1 for UI elements and graphics`}</li>
      <li parentName="ul">{`No contrast requirement for decorative and disabled elements`}</li>
    </ul>
    <p>{`Use an `}<a parentName="p" {...{
        "href": "https://webaim.org/resources/contrastchecker/"
      }}>{`online contrast checker`}</a>{` or a `}<a parentName="p" {...{
        "href": "/guides/accessibility/tools#contrast-plugin"
      }}>{`Figma plugin`}</a>{` to test your contrast.`}</p>
    <p>{`If you work with the `}<a parentName="p" {...{
        "href": "#color-roles-recipes"
      }}>{`functional colors`}</a>{`, this work has already been done for you. We checked all recommended combinations, so you are all set.`}</p>
    <h3>{`Don't rely on color alone`}</h3>
    <Box mb={3} display="flex" alignItems="flex-start" alignItems="center" flexDirection={['column', 'column', 'column', 'column', 'row']} sx={{
      gap: 3
    }} mdxType="Box">
  <Box as="p" mt="0" mdxType="Box">
    <Heading sx={{
          mt: 0,
          mb: 3,
          fontSize: 2
        }} as="h4" mdxType="Heading">
      Show state with more than color
    </Heading>
    Color vision deficiency is different for different people. To make sure everyone can understand and use your UI you should
    show state with more than a change in color. For example by using icons or changing the content.
  </Box>
  <img width="456" alt="Example icon that uses a distinct shape in addition to color to indicate an error." src="https://user-images.githubusercontent.com/813754/187186864-8a825434-978b-4e21-bac2-9c1235d75e2c.png" />
    </Box>
    <Box mb={3} display="flex" alignItems="flex-start" alignItems="start" flexDirection={['column', 'column', 'column', 'column', 'row']} sx={{
      gap: 3
    }} mdxType="Box">
  <Box as="p" mt="0" mdxType="Box">
    <Heading sx={{
          mt: 0,
          mb: 3,
          fontSize: 2
        }} as="h4" mdxType="Heading">
      Connect labels to graphs with lines or patterns
    </Heading>
    For charts and graphs you can position the labels on top or close to each section. You can also use patterns to distinguish
    different parts.
  </Box>
  <img width="456" alt="Two graphs. One is a line graph and one is a pie graph. The line graph is demonstrating using unique shapes for each comparison line's plot symbol. The pie chart is demonstrating how each slice's label can use a line to point to its corresponding slide." src="https://user-images.githubusercontent.com/813754/187186931-84bcc541-7cea-45f2-a686-21c5428e0620.png" />
    </Box>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      